var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user && !_vm.user.isAdmin
    ? _c("div", { staticClass: "flex flex-wrap" }, [
        _c(
          "div",
          { staticClass: "w-full md:w-3/4 md:pr-20" },
          [
            _c(
              "div",
              { staticClass: "border-b border-gray-hr" },
              [
                _c("h1", { staticClass: "mb-5 text-n-gray-dark" }, [
                  _vm._v("Your Upcoming Events"),
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "button mb-12",
                    attrs: { to: "/events/create" },
                  },
                  [_vm._v("\n        Create New Event\n      ")]
                ),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-wrap -mx-6 pt-12" },
              _vm._l(_vm.events, function (event) {
                return _c("dashboard-event-item", {
                  key: event.id,
                  attrs: { event: event },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "button button__medium mb-10",
                attrs: { to: "/past-events" },
              },
              [_vm._v("\n      View Past Events\n    ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "w-full md:w-1/4 md:pt-40" }, [
          _c(
            "div",
            { staticClass: "sidebar-block border-t-5 border-black pt-3" },
            [
              _c("public-profile-link"),
              _vm._v(" "),
              _c(
                "h2",
                { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" },
                [_vm._v("Help with My Events")]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("support"),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-8" }, [
      _c("p", { staticClass: "mb-5" }, [
        _vm._v(
          "\n          Your event dashboard is where you’ll see the event(s) you’re working on and the status (draft, in review, published, etc.) You can select the saved event to make edits. If you ever lose your way in the portal, click the “My Events” tab in the top navigation. You can begin adding an event by clicking \"Create New Event.” Once submitted, Reimagine will review your event to ensure it's aligned with our mission and values prior to publishing. Reimagine reserves the right to not publish an event.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/hc/en-us/sections/360008557151-Creating-submitting-your-events",
            },
          },
          [_vm._v("Creating & Submitting Events")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }